module.exports = __webpack_public_path__ + "img/home-solution-haiyang.4417ecfe.png";